
import _ from "lodash"
import { Select, Option, Switch, Input } from "element-ui"
import Cookies from "js-cookie"
import { getGoogleMapAddress, addAddress, modifyAddress } from "@/api/address"
import { getCurrentAddress, resetStoreInfo } from "@/utils/utils"
import collapseTransition from "@/library/collapse-transition.js"
import { trackShippingInfo } from "@/utils/track"
import { getRootStyle } from "@/utils/head"
import { getCommonParam } from "@/plugins/env"
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Switch.name]: Switch,
    [Input.name]: Input,
    collapseTransition
  },
  directives: {
    "click-outside": {
      inserted: function (el, binding, vnode) {
        const parentEl = document.getElementById("area-code-select")
        el.event = function (event) {
          if (!(el === event.target || el.contains(event.target)) && !(parentEl && parentEl.contains(event.target))) {
            if (typeof vnode.context[binding.expression] === "function") {
              vnode.context[binding.expression](event)
            }
          }
        }
        document.body.addEventListener("click", el.event, true)
      },
      unbind: function (el) {
        document.body.removeEventListener("click", el.event, true)
      }
    }
  },
  props: {
    type: {
      type: String,
      default: "add"
    },
    addresses: {
      type: Object,
      default: () => {}
    },
    addNew: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      addressObj: {
        consignee: "",
        mobilPhone: "",
        areaCode: "",
        phone: "",
        address: "",
        unitFloor: "",
        buildingEstate: "",
        label: "",
        lat: null,
        lng: null,
        priority: false,
        address1: "",
        address2: "",
        region: ""
      },
      options: [],
      labelList: [
        {
          name: this.$t("address.home"),
          value: "Home",
          icon: "Home"
        },
        {
          name: this.$t("address.work"),
          value: "Work",
          icon: "Work"
        },
        {
          name: this.$t("address.other"),
          value: "Other",
          icon: "Add"
        }
      ],
      placeholderAddress: this.$t("address.pleaseFillYourAddressHere"),
      placeholderFloor: this.$t("address.EgUnit606"),
      placeholderBuild: this.$t("address.pleaseFill"),
      placeholderLable: this.$t("address.enterAddressLabel"),
      readyConfim: false,
      activeItem: {},
      showLabelInput: false,
      priority: "",
      noDataText: this.$t("address.noData"),
      loadingText: this.$t("address.loadingText"),
      selLoading: false,
      placeholderName: this.$t("address.pleaseEnterName"),
      placeholderPhone: this.$t("address.pleaseEnterPhoneNumber"),
      codeListShow: false,
      codeOptions: [
        {
          value: "+852",
          label: "+852"
        },
        {
          value: "+853",
          label: "+853"
        },
        {
          value: "+86",
          label: "+86"
        }
      ],
      invalid: false,
      activeColor: ""
    }
  },
  computed: {
    inputChange() {
      const { address2, unitFloor, phone, consignee, areaCode } = this.addressObj
      return { address2, unitFloor, phone, consignee, areaCode }
    }
  },
  watch: {
    inputChange: {
      handler(newValue, oldValue) {
        const { address2, unitFloor, phone, consignee, areaCode } = newValue
        if (address2 && unitFloor.trim() && phone && consignee.trim() && areaCode && !this.invalid) {
          this.readyConfim = true
        } else {
          this.readyConfim = false
        }
      },
      deep: true
    },
    addresses: {
      handler(newValue, oldValue) {
        this.activeItem = {}
        if (this.type == "edit" && newValue) {
          this.initAddress(newValue)
        } else {
          this.addressObj = {
            consignee: "",
            mobilPhone: "",
            areaCode: "",
            phone: "",
            address: "",
            unitFloor: "",
            buildingEstate: "",
            label: "",
            lat: null,
            lng: null,
            priority: false,
            address1: "",
            address2: "",
            region: ""
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {},
  mounted() {
    const { primaryColor } = getRootStyle()
    this.activeColor = primaryColor
  },
  methods: {
    initAddress(addresses) {
      console.log("initAddress", addresses)
      if (addresses.mobilPhone && addresses.mobilPhone.includes(" ")) {
        addresses.areaCode = addresses.mobilPhone.split(" ")[0]
        addresses.phone = addresses.mobilPhone.split(" ")[1]
        if (!addresses.areaCode.includes("+")) {
          addresses.areaCode = "+" + addresses.areaCode
        }
      } else {
        addresses.phone = addresses.mobilPhone
        addresses.areaCode = ""
      }
      this.addressObj = _.cloneDeep(addresses)
      this.addressObj.priority = this.addressObj.priority == "Default"

      this.activeItem = {
        value: addresses.label
      }
      if (addresses.label && !this.labelList.find(item => item.value == addresses.label)) {
        this.activeItem = {
          value: "Other"
        }
      }
    },
    getAddress(query) {
      if (query !== "") {
        this.selLoading = true
        getGoogleMapAddress({
          param: JSON.stringify({
            keyword: query
          })
        })
          .then(res => {
            this.options = res.data
            this.selLoading = false
          })
          .catch(err => {
            console.log(err)
            this.selLoading = false
          })
      }
    },

    async handleConfirm() {
      if (!this.readyConfim) {
        return
      }
      const currentAddress = getCurrentAddress()
      const isCurrent = currentAddress && currentAddress.id == this.addressObj.id
      const address2 = this.addressObj.address2
      const params = {
        address: "",
        address2: address2.address ? encodeURIComponent(address2.address) : encodeURIComponent(address2),
        addressName: address2.name ? encodeURIComponent(address2.name) : "",
        unitFloor: encodeURIComponent(this.addressObj.unitFloor.trim()),
        buildingEstate: encodeURIComponent(this.addressObj.buildingEstate.trim()),
        priority: this.addressObj.priority == true ? "Default" : null,
        phone: this.addressObj.areaCode + " " + this.addressObj.phone,
        consignee: encodeURIComponent(this.addressObj.consignee.trim()),
        label: this.addressObj.label
          ? encodeURIComponent(this.addressObj.label)
          : this.activeItem.value
            ? encodeURIComponent(this.activeItem.value)
            : "",
        lat: address2.address ? address2.latitude : this.addressObj.lat,
        lng: address2.address ? address2.longitude : this.addressObj.lng
      }
      let handleFun = addAddress
      if (this.type == "edit") {
        params.id = this.addressObj.id
        params.type = this.addressObj.type
        handleFun = modifyAddress
      }
      const { shipmentType } = getCommonParam()
      try {
        const { data } = await handleFun({ param: JSON.stringify(params) })
        const accountInfo = await this.$store.dispatch("getLoginInfo")
        if (data && data.msg) {
          this.$message({
            message: data.msg,
            type: "warning"
          })
          return false
        } else {
          this.$message({
            message: this.type == "edit" ? this.$t("address.addressUpdated") : this.$t("address.addressAdded"),
            type: "success"
          })
        }
        if (shipmentType == 2) {
          this.$emit("update")
        } else {
          if (isCurrent) {
            const address =
              accountInfo && accountInfo.address && accountInfo.address.filter(item => item.id == this.addressObj.id)
            await resetStoreInfo(address[0])
            this.$emit("close", "all")
          } else {
            if (accountInfo && accountInfo.address && accountInfo.address.length == 1) {
              // 无地址新增一条
              await resetStoreInfo(accountInfo.address[0])
              this.$emit("close", "all")
            }
            this.$emit("update")
          }
        }
        trackShippingInfo(address2.address ? address2.address : address2)
      } catch (error) {
        // loading.close()
      }
    },
    handleLabelClick(item) {
      this.addressObj.label = ""
      this.activeItem = item
      // this.addressObj.label = item.value
    },
    isActive(item) {
      return this.activeItem.value == item.value
    },
    handelSwitchChange(val) {
      console.log(val)
    },
    handleBack() {
      if (this.type == "add") {
        this.$emit("back")
      } else {
        const priority = this.addressObj.priority ? "Default" : null
        if (
          this.addressObj.address2 != this.addresses.address2 ||
          this.addressObj.unitFloor != this.addresses.unitFloor ||
          this.addressObj.buildingEstate != this.addresses.buildingEstate ||
          priority != this.addresses.priority
        ) {
          this.$messageBox
            .open({
              title: this.$t("address.leavePageTipsTile"),
              message: this.$t("address.leavePageTips"),
              cancelText: this.$t("address.returnToSite"),
              confirmText: this.$t("address.continueEdit"),
              showClose: false,
              disMaskClick: true
            })
            .then(() => {})
            .catch(() => {
              this.$emit("back")
            })
        } else {
          this.$emit("back")
        }
      }
    },
    clear() {
      // fix ios el-select 无法唤起键盘
      this.$nextTick(() => {
        // ios 手机有延迟问题
        setTimeout(() => {
          const { select } = this.$refs
          const input = select.$el.querySelector(".el-input__inner")
          input.removeAttribute("readonly")
        }, 200)
      })
    },
    hideCodeList() {
      this.codeListShow = false
    },
    toggleCodeListShow() {
      this.codeListShow = !this.codeListShow
    },
    handleSelect(item) {
      if (this.addressObj.areaCode !== item.value) {
        this.addressObj.areaCode = item.value
        this.checkInput()
      }
      this.hideCodeList()
    },
    handleInput(value) {
      // 限制输入数字

      if (value) {
        this.addressObj.phone = value.replace(/[^\d]/g, "")
        // this.$nextTick(() => {
        this.checkInput()
        // })
      }
    },
    checkInput() {
      const { areaCode, phone } = this.addressObj
      if (areaCode === "+86") {
        // 限制11位数 || 1开头
        if (phone.length !== 11 || !/^1\d{10}$/.test(phone)) {
          this.invalid = true
          this.invalidText = this.$t("cart.recipientWarningTextWith11Digits")
        } else {
          this.resetInvalidNotice()
        }
      } else {
        // 限制8位数

        if (phone.length !== 8) {
          this.invalid = true
          this.invalidText = this.$t("cart.recipientWarningTextWith8Digits")
        } else {
          this.resetInvalidNotice()
        }
      }
    },
    resetInvalidNotice() {
      this.invalid = false
      this.invalidText = ""
    }
  }
}
